import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { GrabExpress, GrabExpressVariables } from "./types/GrabExpress";
import {
  GrabExpressDownload,
  GrabExpressDownloadVariables
} from "./types/GrabExpressDownload";
import {
  InitialGrabExpressFilterData,
  InitialGrabExpressFilterDataVariables
} from "./types/InitialGrabExpressFilterData";

export const GrabExpressQuery = gql`
  ${pageInfoFragment}
  query GrabExpress(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: GrabExpressFilterInput!
  ) {
    grabExpress(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          booked_at
          canceled_at
          cod_amount
          completed_at
          delivery_cost
          delivery_status
          grab_payment_method
          id
          mall_name
          ops_firstname
          ops_lastname
          order_code
          order_date
          payment_method_type
          reference_no
          returned_at
          rider_contact_no
          rider_firstname
          rider_lastname
          service_type
          shipped_at
          shipping_company
          status
          trip_distance
        }
      }
    }
  }
`;

export const useGrabExpressListQuery = makeBossQuery<
  GrabExpress,
  GrabExpressVariables
>(GrabExpressQuery);

export const initialGrabExpressFilterDataQuery = gql`
  query InitialGrabExpressFilterData($mall: [ID]) {
    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialGrabExpressFilterDataQuery = makeQuery<
  InitialGrabExpressFilterData,
  InitialGrabExpressFilterDataVariables
>(initialGrabExpressFilterDataQuery);

export const grabExpressDownloadQuery = gql`
  ${pageInfoFragment}
  query GrabExpressDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: GrabExpressFilterInput!
  ) {
    grabExpress(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          booked_at
          canceled_at
          cod_amount
          completed_at
          delivery_cost
          delivery_status
          grab_payment_method
          id
          mall_name
          ops_firstname
          ops_lastname
          order_code
          order_date
          payment_method_type
          reference_no
          returned_at
          rider_contact_no
          rider_firstname
          rider_lastname
          service_type
          shipped_at
          shipping_company
          status
          trip_distance
        }
      }
    }
  }
`;

export const useGrabExpressDownloadQuery = makeBossQuery<
  GrabExpressDownload,
  GrabExpressDownloadVariables
>(grabExpressDownloadQuery);
